import {StyleSheet, Dimensions} from 'react-native';
import {styles} from 'src/theme';
import {customResponsiveWidth} from '../../../../../utils/CustomResponsive';
import {windowWidth} from '../../../../../constants';
const {width, height} = Dimensions.get('window');
export default StyleSheet.create({
  slide: {
    alignItems: 'center',
    height: '100%',
    backgroundColor: 'blue',
    width: '100%',
  },
  title: {
    color: '#303261',
    fontSize: 18,
    marginBottom: 14,
    fontFamily: styles.font.IranYekan[400],
  },
  text: {
    color: '#303261',
    fontSize: 14,
    marginBottom: 50,
    fontFamily: styles.font.IranYekan[400],
    textAlign: 'center',
  },
  textContainer: {
    width: windowWidth - 30,
    alignItems: 'center',
  },
  buttontext: {
    fontSize: 18,
    fontFamily: styles.font.IranYekan[400],
  },
  btncontainer: {
    width: '100%',
    paddingHorizontal: 24,
    paddingBottom: 24,
    height: 120,
    position: 'absolute',
    bottom: 0,
    justifyContent: 'flex-end',
  },
  imageContainer: {
    padding: 10,
    justifyContent: 'center',
    backgroundColor: '#fff',
    alignItems: 'center',
    width: customResponsiveWidth(52),
    height: customResponsiveWidth(52),
    borderRadius: 18,
  },
  container: {
    flex: 1,
    backgroundColor: '#fff',
    paddingHorizontal: 4,
    alignItems: 'center',
    justifyContent: 'center',
  },
  header: {
    width: '98%',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'center',
    marginBottom: 10,
  },
  headerTitle: {
    color: '#2D2D2D',
    fontSize: 14,
    fontFamily: styles.font.IranYekan[400],
    textAlign: 'flex-end',
    paddingRight: 12,
    marginLeft: 'auto',
  },
  description: {
    color: '#5A5A5A',
    fontSize: 13,
    fontFamily: styles.font.IranYekan[400],
    textAlign: 'center',
    paddingVertical: 3,
    paddingHorizontal: 9,
  },
  description2: {
    color: '#5A5A5A',
    fontSize: 13,
    fontFamily: styles.font.IranYekan[400],
    width: '80%', // متن در یک بلوک با عرض مشخص
    writingDirection: 'rtl', // پشتیبانی کامل از فارسی
    paddingVertical: 3,
    paddingHorizontal: 9,
  },
  container2: {
    alignItems: 'center', // این باعث می‌شه بلوک کلی وسط صفحه باشه
    width: '100%',
  },
  textWrapper: {
    width: '90%', // کنترل عرض بلوک متن
    alignItems: 'center', // برای راست‌چین کردن خطوط داخل بلوک
  },
  linkButton: {
    paddingVertical: 8,
  },
  linkText: {
    color: '#223EB9',
    fontSize: 14,
    fontFamily: styles.font.IranYekan[400],
    textAlign: 'center',
  },
  tabs: {
    flexDirection: 'row',
    margin: 16,
    borderBottomWidth: 1,
    borderColor: '#ECEDF0',
    flex: 1,
    width: '95%',
  },
  tab: {
    flex: 0.8,
    alignItems: 'center',
  },
  activeTab: {
    borderBottomWidth: 3,
    borderColor: '#F34F42',
  },
  tabText: {
    fontSize: 14,
    fontFamily: styles.font.IranYekan[500],
    textAlign: 'center',
    color: '#434343',
  },
  activeTabText: {
    color: '#B91618',
    fontSize: 14,
    fontFamily: styles.font.IranYekan[500],
    textAlign: 'center',
  },
  cardsContainer: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    width: '95%',
    marginTop: 10,
  },
  card: {
    borderRadius: 8,

    backgroundColor: '#fff',
    flex: 1,
  },
  cardIcon: {
    position: 'absolute',
    top: -5,
    right: 5,
  },
  map: {
    width: '98%',
    height: '98%',
    marginTop: 10,
  },
  closeBtn: {
    alignSelf: 'flex-start',
  },
});
